import { Component, OnInit, Input } from '@angular/core';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ResultConfigDTO } from './model/result-config-dto';
import { SelectItem, ConfirmationService, Message } from 'primeng/api';
import { KitsDTO } from '../masterdata/models/kits-dto';
import { Channels, RuleSet, ResultSet } from './model/result-channels';
import { MachineManufacturerOptionsCycler, MachineManufacturerOptionOther } from '../crud-table/machine-options';

@Component({
  selector: 'app-result-engine-config',
  templateUrl: './result-engine-config.component.html',
  styleUrls: ['./result-engine-config.component.css']
})
export class ResultEngineConfigComponent implements OnInit {

  @Input() masterLists: any[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() checkSelectedLab: SelectableLab;

  labOption: LabMDM[]=[];

  readonly NOT_USED_LABEL = 'Not Used';

  selectedMasterList: ResultConfigDTO;
  buttonLabel = 'Create';
  verifiedResult: boolean = false;
  showDialogToAddOrUpdateResult = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  resultConfig: ResultConfigDTO;
  selectedLabName: string;
  selectedLab: LabMDM;
  selectedLabId: string;
  newResult: boolean;

  kits: SelectItem[] = [];
  cyclers: SelectItem[] = [];
  cyclerMachine: SelectItem[] = [];

  messages: Message[] = [];

  firstChannelList: SelectItem[] = [];
  secondChannelList: SelectItem[] = [];
  thirdChannelList: SelectItem[] = [];

  channnelValueOptions: SelectItem[] = [
    {label: 'Low Cp', value: 'low'},
    {label: 'High Cp', value: 'high'},
    {label: 'Medium Cp', value: 'medium'},
    {label: 'No Signal', value: 'nosignal'}
  ];

  mapOfChannelValue = new Map();
  mapOfResultValue = new Map();

  ruleResultOptions: SelectItem[] = [
    {label: 'Positive', value: 'positive'},
    {label: 'Negative', value: 'negative'},
    {label: 'Retest', value: 'retest'},
    {label: 'Invalid', value: 'invalid'},
    {label: 'Check', value: 'check'}
  ];

  channelFieldNames = ['channel1Gene','channel2Gene','channel3Gene','channel4Gene','channel5Gene'];

  kitMap: Map<string, KitsDTO> = new Map<string, KitsDTO>();
  selectedKit: KitsDTO;
  resultChannels : Channels[] = [];
  ruleSet: RuleSet = new RuleSet();
  ruleSetTable: RuleSet[] = [];
  selectedChannels: string[] = [this.NOT_USED_LABEL, this.NOT_USED_LABEL, this.NOT_USED_LABEL];
  channelCount = 0;
  kitChannelCount: number;
  activeIndexs: number[] = [];
  ruleKeyMap: Map<string, string> = new Map<string, string>();

  selectedKitBkp = null;
  selectedCyclerBkp = null;
  resultNameBkp = null;
  ruleTableHeaders: string[] = [];

  ruleError: string;
  showErrorMessage: boolean = false;

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.resultConfig = new ResultConfigDTO();
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.newResult = false;

    this.mapOfChannelValue.set('low', 'Low Cp');
    this.mapOfChannelValue.set('high', 'High Cp');
    this.mapOfChannelValue.set('medium', 'Medium Cp');
    this.mapOfChannelValue.set('nosignal', 'No Signal');

    this.mapOfResultValue.set('positive', 'Positive');
    this.mapOfResultValue.set('negative', 'Negative');
    this.mapOfResultValue.set('retest', 'Retest');
    this.mapOfResultValue.set('invalid', 'Invalid');
    this.mapOfResultValue.set('check', 'Check');
    this.ruleSet = {
      'channelValues' : ['nosignal', 'nosignal', 'nosignal'],
      'channelResult' : 'retest'
    }
    this.intializeResultChannels();
  }

  intializeResultChannels() {
    this.resultChannels = [];
    for(let i = 0; i < 3; i++) {
      let newResultChannel = new Channels();
      newResultChannel.channelName = this.NOT_USED_LABEL;
      newResultChannel.lowCp = 0;
      newResultChannel.highCp = 0;
      newResultChannel.colPosition = i;
      this.resultChannels.push(Object.assign({}, newResultChannel));
    }
  }

  showDialogToAddResultConfig() {
    this.getActiveOptionsForDropdowns();
    this.initializeAfterShowDialog();
  }

  initializeAfterShowDialog() {
    this.verifiedResult = false;
    this.resultConfig = new ResultConfigDTO();
    this.resultConfig.resultSet = [];
    this.resultConfig.channelThreshold = [];
    this.initializeForOnSelect();
  }

  initializeForOnSelect() {
    this.intializeResultChannels();
    this.ruleSet = new RuleSet();
    this.ruleSet.channelValues = ['nosignal', 'nosignal', 'nosignal'];
    this.ruleSet.channelResult = 'retest';
    this.ruleSetTable = [];
    this.showErrorMessage = false;
    this.ruleKeyMap = new Map();
    this.activeIndexs = [];
    this.selectedChannels = [this.NOT_USED_LABEL, this.NOT_USED_LABEL, this.NOT_USED_LABEL];
    this.showDialogToAddOrUpdateResult = true;
  }

  //Retrieve the Active lab for dropdown
  getActiveOptionsForDropdowns() {
    this.labOption=[];
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.labOption = results.data;
        this.labChooser();
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );

    this.populateMachineAndKitsDropdown();
  }

  populateMachineAndKitsDropdown() {
    this._masterDataService.getKitsFromMDM(this.selectedLabId, null, [].join(','), [].join(',')).subscribe(
      results => {
        this.kits = [];
        const mapKits = new Map(Object.entries(results.data));
        this.kits = this.convertArrayOfStringToObjectArray(mapKits, "pcr");
        if(this.resultConfig && !this.newResult) {
          this.changeSelectedKitAction({value: this.resultConfig.kitName});
          this.verifyIfChannelRemoved();
          this.initalizeTablesFromResultConfig();
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messages.push(message);
      }
    );
    this.cyclers = this.getAllManufacturerOptions();
  }

  getAllManufacturerOptions() {
    return MachineManufacturerOptionsCycler.concat(MachineManufacturerOptionOther);
  }

  convertArrayOfStringToObjectArray(objectToArray: Map<string, Object>, kitType: string) {
    let newArray: any[] = [];
    this.kitMap = new Map<string, KitsDTO>();
    Object.entries(objectToArray.get(kitType)).forEach(([key, value]) => {
      let obj: KitsDTO = value;
      this.kitMap.set(key, obj);
      newArray.push({ label: key, value: key });
    });
    return newArray;
  }

  handleUpdateAndCreateOfResult() {
    let masterLists = [...this.masterLists];
    this.resultConfig.kitNameCyclerResultName = this.resultConfig.kitName + '#' + this.resultConfig.cycler + '#' + this.resultConfig.resultName.trim();
    if(this.verifiedResult) {
      if(this.newResult) {
        this.addResultLogic(masterLists);
      } else {
        this.updateResultLogic(masterLists);
      }
    } else {
      this.messages = [];
      this.resultCreationDecider();
    }
  }

  addResultLogic(masterLists: ResultConfigDTO[]) {
    this.resultConfig.channelThreshold = this.getValidChannelsToInsert();
    this.resultConfig.kitNameCyclerResultName = this.resultConfig.kitName + '#' + this.resultConfig.cycler + '#' + this.resultConfig.resultName.trim();
    this._masterDataService.addResultLogic(this.resultConfig).subscribe(
      result => {
        if (!result) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(result.data);
        this.masterLists = masterLists;
        this.showDialogToAddOrUpdateResult = false;
        this._messageService.addSuccessMessage({severity: 'success', summary: 'Configuration Added',
                detail: 'Configuration '+ this.resultConfig.resultName +' has been successfully added'});
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messages.push(message);
      }
    );
  }

  getValidChannelsToInsert() {
    let validResultChannels = [];
    if(this.resultConfig.isChannelRemoved) {
      this.resultConfig.channelThreshold = [];
      this.resultConfig.resultSet = [];
      this.ruleKeyMap = new Map();
      this.ruleSetTable = [];
      return;
    }
    this.resultChannels.forEach(channel => {
      if(channel.channelName && channel.channelName != this.NOT_USED_LABEL && channel.channelName.trim() != '') {
        if(this.isChannelPresentInKit(channel.channelName)) {
          validResultChannels.push(channel);
        } else {
          this.resultConfig.resultSet = [];
          this.ruleKeyMap = new Map();
          this.ruleSetTable = [];
        }
      }
    });
    return validResultChannels;
  }

  updateResultLogic(masterLists: ResultConfigDTO[]) {
    this.resultConfig.channelThreshold = this.getValidChannelsToInsert();
    this.resultConfig.kitNameCyclerResultName = this.resultConfig.kitName + '#' + this.resultConfig.cycler + '#' + this.resultConfig.resultName.trim();
    this._masterDataService.updateResultLogic(this.resultConfig).subscribe(
      result => {
        if (!result) {
          return;
        }
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = result.data;
        this.masterLists = masterLists;
        this.showDialogToAddOrUpdateResult = false;
        this._messageService.addSuccessMessage({severity: 'success', summary: 'Configuration Updated',
            detail: 'Configuration '+ this.resultConfig.resultName +' has been successfully updated'});
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messages.push(message);
      }
    );
  }

  resultCreationDecider() {
    this._masterDataService.getResultForKitCyclerResultCombo(this.selectedLabId, this.resultConfig.kitNameCyclerResultName).subscribe(
      result => {
        if(result.data) {
          this.newResult = false;
          this.resultConfig = result.data;
          this.labChooser();
          this.selectedKitBkp = this.resultConfig.kitName;
          this.selectedCyclerBkp = this.resultConfig.cycler;
          this.resultNameBkp = this.resultConfig.resultName;
          this.messages.push({severity: 'success', summary: 'Matching Record found',
          detail: 'Matching record with kit: '+ this.resultConfig.kitName + ', cycler: '+ this.resultConfig.cycler +', and name: '+ this.resultConfig.resultName
                + ' has been found'});
          this.changeSelectedKitAction({'value':this.resultConfig.kitName});
          this.initalizeTablesFromResultConfig();
        } else {
          this.newResult = true;
        }
        this.verifiedResult = true;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messages.push(message);
      }
    );
   }

  initalizeTablesFromResultConfig() {
    this.intializeResultChannels();
    this.activeIndexs = [];
    this.ruleTableHeaders = [];
    if(this.resultConfig.channelThreshold && this.resultConfig.channelThreshold.length > 0) {
      this.resultChannels.forEach(target => {
        this.resultConfig.channelThreshold.forEach(source => {
          if(source.colPosition == target.colPosition) {
            target.channelName = source.channelName;
            target.lowCp = source.lowCp;
            target.highCp = source.highCp;
            if(this.isChannelPresentInKit(target.channelName)) {
              this.activeIndexs.push(target.colPosition);
              this.ruleTableHeaders.push(target.channelName);
            }
          }
        });
      });
      this.ruleTableHeaders.push('Result');
      this.ruleTableHeaders.push('Action');
      this.ruleKeyMap = new Map();
      this.ruleSetTable = [];
      this.calibrateOptionsOnDialogShow();
      if(this.resultConfig.resultSet && this.resultConfig.resultSet.length > 0) {
        this.resultConfig.resultSet.forEach(result => {
          this.ruleKeyMap.set(result.rule, result.result);
          this.ruleSetTable.push(this.createRuleSetFromResultSet(result));
        });
      }
    } else {
      this.resultConfig.resultSet = [];
      this.resultConfig.channelThreshold = [];
      this.initializeForOnSelect();
      this.changeSelectedKitAction({'value':this.resultConfig.kitName});
    }
  }

  createRuleSetFromResultSet(resultSet: ResultSet) {
    let ruleSet = new RuleSet();
    ruleSet = {
      'channelValues' : ['nosignal', 'nosignal', 'nosignal'],
      'channelResult' : 'retest'
    };
    let rulekeys = resultSet.rule.split('_');
    let i = 0;
    this.activeIndexs.forEach(index => {
      ruleSet.channelValues[index] = rulekeys[i++];
    });
    ruleSet.channelResult = resultSet.result;
    return ruleSet;
  }

  getButtonLabel() {
    return this.verifiedResult ? 'Save' : 'Create';
  }

  onRowSelect(event: any) {
    this.resultConfig = Object.assign({}, event.data);
    this.newResult = false;
    this.verifiedResult = true;
    this.messages = [];
    this.showErrorMessage = false;
    this.selectedKitBkp = this.resultConfig.kitName;
    this.selectedCyclerBkp = this.resultConfig.cycler;
    this.resultNameBkp = this.resultConfig.resultName;
    this.getActiveOptionsForDropdowns();
    this.showDialogToAddOrUpdateResult = true;
  }

  isColumnedEnabled(columnIndex: number) {
    return (this.kitChannelCount > columnIndex) ;
  }

  isCutOffColumnedDisabled(columnIndex: number) {
    return (this.resultChannels[columnIndex].channelName == this.NOT_USED_LABEL);
  }

  calibrateOptions(columnChanged: number) {
    if(this.selectedChannels[columnChanged] == this.NOT_USED_LABEL) {
      if(this.ruleSetTable.length > 0) {
        this.confirmationServiceForTableResetOnChannelActivation(columnChanged);
      } else {
        this.removalActions(columnChanged);
      }
    } else if(this.resultChannels[columnChanged].channelName == this.NOT_USED_LABEL) {
      if(this.ruleSetTable.length > 0) {
        this.confirmationServiceForTableResetOnChannelDeactivation(columnChanged);
      } else {
        this.resultChannels[columnChanged].lowCp = 0;
        this.resultChannels[columnChanged].highCp = 0;
        this.additionActions(columnChanged);
      }
    } else {
      this.removeOption(columnChanged, this.resultChannels[columnChanged].channelName);
      this.addOption(columnChanged, this.selectedChannels[columnChanged]);
      this.selectedChannels[columnChanged] = this.resultChannels[columnChanged].channelName;
      this.activeIndexs = this.calculateActiveChannelIndexes();
      this.ruleTableHeaders = this.getRuleSetTableHeaders();
    }
  }

  confirmationServiceForTableResetOnChannelActivation(columnChanged: number) {
    this.confirmationService.confirm({
      message: 'This will clear out the results rules already set. Are you sure you want to change this channel selection?',
      header: 'Discard Changes?',
      accept: () => {
        this.ruleSetTable = [];
        this.resultConfig.resultSet = [];
        this.ruleKeyMap = new Map<string, string>();
        this.removalActions(columnChanged);
      },
      reject: () => {
        this.resultChannels[columnChanged].channelName = this.selectedChannels[columnChanged];
      }
    });
  }

  removalActions(columnChanged: number) {
    this.removeOption(columnChanged, this.resultChannels[columnChanged].channelName);
    this.selectedChannels[columnChanged] = this.resultChannels[columnChanged].channelName;
    this.activeIndexs = this.calculateActiveChannelIndexes();
    this.ruleTableHeaders = this.getRuleSetTableHeaders();
  }

  confirmationServiceForTableResetOnChannelDeactivation(columnChanged: number) {
    this.confirmationService.confirm({
      message: 'This will clear out the results rules already set. Are you sure you want to change this channel selection?',
      header: 'Discard Changes?',
      accept: () => {
        this.ruleSetTable = [];
        this.resultConfig.resultSet = [];
        this.ruleKeyMap = new Map<string, string>();
        this.resultChannels[columnChanged].lowCp = 0;
        this.resultChannels[columnChanged].highCp = 0;
        this.additionActions(columnChanged);
      },
      reject: () => {
        this.resultChannels[columnChanged].channelName = this.selectedChannels[columnChanged];
      }
    });
  }

  additionActions(columnChanged: number) {
    this.addOption(columnChanged, this.selectedChannels[columnChanged]);
    this.selectedChannels[columnChanged] = this.resultChannels[columnChanged].channelName;
    this.activeIndexs = this.calculateActiveChannelIndexes();
    this.ruleTableHeaders = this.getRuleSetTableHeaders();
  }

  removeOption(columnIndex: number, optionToRemove: string) {
    let options = ['firstChannelList', 'secondChannelList', 'thirdChannelList'];
    for(let i = 0; i < 3; i++) {
      if(i != columnIndex) {
        let index = this.findIndexOfChannel(optionToRemove, this[options[i]]);
        if(index != -1) {
          this[options[i]].splice(index, 1);
        }
      }
    }
  }

  findIndexOfChannel(searchItem: string, channelList: SelectItem[]) {
    let foundIndex = -1;
    for(let i = 0; i < channelList.length; i++) {
      if(channelList[i].value == searchItem) {
        return i;
      }
    }
    return foundIndex;
  }

  addOption(columnIndex: number, optionToRemove: string) {
    let options = ['firstChannelList', 'secondChannelList', 'thirdChannelList'];
    let selectedItemObject = {label: optionToRemove, value: optionToRemove};
    for(let i = 0; i < 3; i++) {
      if(i != columnIndex && this.isChannelPresentInKit(optionToRemove)) {
        this[options[i]].push(selectedItemObject);
      }
    }
  }

  isChannelConfigurable(channelNumber: number) {
    return (this.activeIndexs.includes(channelNumber))
  }

  isCreateDisabled() {
    return (!this.resultConfig || !this.resultConfig.kitName || !this.resultConfig.cycler || !this.resultConfig.resultName || (this.resultConfig.resultName.trim() == '' ))
  }

  getRuleSetTableHeaders() {
    let ruleSetTableHeaders = [];
    if(this.resultChannels) {
      this.resultChannels.forEach(resultChannel => {
        if(resultChannel.channelName !== this.NOT_USED_LABEL && this.isChannelPresentInKit(resultChannel.channelName)) {
          ruleSetTableHeaders.push(resultChannel.channelName);
        }
      });
      ruleSetTableHeaders.push('Result');
      ruleSetTableHeaders.push('Action');
    }
    return ruleSetTableHeaders;
  }

  calculateActiveChannelIndexes() {
    let i = [];
    if(this.resultChannels) {
      let a = 0;
      this.resultChannels.forEach(resultChannel => {
        if(resultChannel.channelName != this.NOT_USED_LABEL && this.isChannelPresentInKit(resultChannel.channelName)) {
          i.push(a);
        }
        ++a;
      });
    }
    return i;
  }

  onRowRemove(ruleSet: RuleSet) {
    let ruleVals: string[] = [];
    this.activeIndexs.forEach(index => {
      ruleVals.push(ruleSet.channelValues[index]);
    });
    let mapKey = ruleVals.join('_');
    this.ruleKeyMap.delete(mapKey);
    this.ruleSetTable.splice(this.ruleSetTable.indexOf(ruleSet), 1);
    let resultSetIndex = this.resultConfig.resultSet.findIndex((value) => value.rule == mapKey);
    this.resultConfig.resultSet.splice(resultSetIndex, 1);
  }

  ruleSetTableVisible() {
    return this.activeIndexs.length > 0;
  }

  changeSelectedKit(event: any) {
    if(this.newResult && this.ruleSetTable && this.ruleSetTable.length == 0) {
      this.changeSelectedKitAction(event);
      this.initializeForOnSelect();
    } else {
      if(!this.areAllChannelsPresentInKit(event.value)) {
        this.confirmationService.confirm({
          message: 'Not all channels are presnt in this kit. This will clear out the rules and values already set. Are you sure you want to change this kit selection?',
          header: 'Discard Changes?',
          accept: () => {
            this.resultConfig.channelThreshold = [];
            this.resultConfig.resultSet = [];
            this.initializeForOnSelect();
            this.changeSelectedKitAction(event);
          },
          reject: () => {
            this.resultConfig.kitName = this.selectedKit.kitName;
          }
        });
      } else {
        this.changeSelectedKitAction(event);
      }
    }
  }

  areAllChannelsPresentInKit(kitName: string) {
    let kit = this.kitMap.get(kitName);
    let allChannelsPresentInKit = true;
    this.resultChannels.forEach(channel => {
      if(!kit || (channel.channelName != this.NOT_USED_LABEL && kit.channel1Gene != channel.channelName && kit.channel2Gene != channel.channelName
          && kit.channel3Gene != channel.channelName && kit.channel4Gene != channel.channelName && kit.channel5Gene != channel.channelName)) {
        allChannelsPresentInKit = false;
      }
    });
    return allChannelsPresentInKit;
  }

  changeSelectedKitAction(event: any) {
    this.selectedKit = new KitsDTO();
    this.selectedKit = this.kitMap.get(event.value);
    this.kitChannelCount = this.getNumberOfChannelsAndIntializeSelection(this.selectedKit);
  }

  channelSelectionListIntialization() {
    this.firstChannelList = [];
    this.secondChannelList = [];
    this.thirdChannelList = [];
    this.firstChannelList.push({label: this.NOT_USED_LABEL, value: this.NOT_USED_LABEL});
    this.secondChannelList.push({label: this.NOT_USED_LABEL, value: this.NOT_USED_LABEL});
    this.thirdChannelList.push({label: this.NOT_USED_LABEL, value: this.NOT_USED_LABEL});
  }

  getNumberOfChannelsAndIntializeSelection(kit: KitsDTO) {
    if(!kit) {
      return 0;
    }
    let count = 0;
    this.channelSelectionListIntialization();
    this.channelFieldNames.forEach(channel=> {
      let channelName = kit[channel];
      if(channelName && (channelName.trim() != '')) {
        this.firstChannelList.push({label: channelName, value: channelName});
        this.secondChannelList.push({label: channelName, value: channelName});
        this.thirdChannelList.push({label: channelName, value: channelName});
      }
      if(kit[channel] && (kit[channel].trim() != '')) {
        count++;
      }
    });
    return count;
  }

  decideOnAddRuleSet() {
    if(this.resultConfig.isChannelRemoved) {
      this.confirmationService.confirm({
        message: 'One or more channels have been removed from the kit being used.' +
          ' Addition of new rule will result in loss of rules already present. Do you wish to continue?',
        header: 'Confirm Rule Addition',
        accept: () => {
          this.ruleSetTable = [];
          this.resultConfig.resultSet = [];
          this.ruleKeyMap = new Map();
          this.resultConfig.isChannelRemoved = false;
          this.addRuleSet();
        },
        reject: () => {}
      });
    } else {
      this.addRuleSet();
    }
  }

  addRuleSet() {
    let ruleKeySet: string[] = [];
    let ruleKey: string = null;
    this.activeIndexs.forEach(index => {
      ruleKeySet.push(this.ruleSet.channelValues[index]);
    });
    ruleKey = ruleKeySet.join('_');
    if(this.ruleKeyMap.has(ruleKey)) {
      this.ruleError = 'Rule already exists';
      this.showErrorMessage = true;
    } else {
      this.showErrorMessage = false;
      this.ruleKeyMap.set(ruleKey, this.ruleSet.channelResult);
      let ruleSetObject = this.createNewRuleSet(this.ruleSet);
      this.ruleSetTable.push(ruleSetObject);
      this.resultConfig.resultSet.push({rule: ruleKey, result: this.ruleSet.channelResult});
      this.intializaeRuleSet(ruleSetObject.channelValues[0], ruleSetObject.channelValues[1], ruleSetObject.channelValues[2], ruleSetObject.channelResult);
    }
  }

  createNewRuleSet(ruleSet: RuleSet) {
    return { channelValues: ruleSet.channelValues, channelResult: ruleSet.channelResult };
  }

  intializaeRuleSet(channel1Value: string, channel2Value: string, channel3Value: string, result: string) {
    this.ruleSet = new RuleSet();
    this.ruleSet.channelValues = [channel1Value, channel2Value, channel3Value];
    this.ruleSet.channelResult = result;
  }

  cloneExistingResultConfig() {
    this.confirmationService.confirm({
      message: 'Do you wish to clone this result defination with the specified changes?',
      header: 'Confirm Cloning',
      accept: () => {
        let newResultConfig = Object.assign({}, this.resultConfig);
        newResultConfig.kitNameCyclerResultName = newResultConfig.kitName + '#' + newResultConfig.cycler + '#' + newResultConfig.resultName.trim();
        newResultConfig._id = null;
        newResultConfig.version = null;
        this._masterDataService.addResultLogic(newResultConfig).subscribe(
          result => {
            if (!result) {
              return;
            }
            this.resultConfig = result.data;
            this._masterDataService.getResultConfigList(this.resultConfig.lab).subscribe(
              results =>{
                this.masterLists = results.data;
                this.masterLists.forEach(entry => {
                  if(entry.kitNameCyclerResultName == this.resultConfig.kitNameCyclerResultName) {
                    this.selectedMasterList = entry;
                  }
                });
              },
              error => {
                let message = this.errorHandler.handleError(error);
                this._messageService.addErrorMessage(message);
              }
            );
            this.messages.push({severity: 'success', summary: 'Cloing Successful',
            detail: 'cloned result engine configuration '+ this.resultConfig.resultName +' has been successfully created'});
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this.messages.push(message);
          }
        );
      },
      reject: () => {
      }
    });
  }

  isCloneEnabled() {
    return (this.selectedKitBkp !== this.resultConfig.kitName) || (this.selectedCyclerBkp !== this.resultConfig.cycler) || (this.resultNameBkp !== this.resultConfig.resultName);
  }

  labChooser() {
    this.labOption.forEach(lab => {
      if(lab._id == this.selectedLabId) {
        this.resultConfig.lab = lab;
      }
    })
  }

  calibrateOptionsOnDialogShow() {
    if(this.resultChannels && this.activeIndexs.length > 0) {
      this.activeIndexs.forEach(index => {
        this.resultChannels.forEach(resultChannel => {
          if(index == resultChannel.colPosition) {
            this.selectedChannels[index] = resultChannel.channelName;
            this.removeOption(index, resultChannel.channelName);
          }
        });
      });
    }
  }

  verifyIfChannelRemoved() {
    this.resultConfig.isChannelRemoved = false;
    if(this.resultConfig && this.resultConfig.channelThreshold && this.resultConfig.channelThreshold.length > 0) {
      this.resultConfig.channelThreshold.forEach(channel => {
        if(!this.isChannelPresentInKit(channel.channelName)) {
          this.messages.push({severity: 'error', summary: 'Kit Channel Removed',
            detail: 'Channel '+ channel.channelName +' has been removed from selected kit. If you press save your current rule set will be lost.'});
          this.resultConfig.isChannelRemoved = true;
        }
      });
    }
  }

  isChannelPresentInKit(channelName: string) {
    return (this.selectedKit && (this.selectedKit.channel1Gene == channelName || this.selectedKit.channel2Gene == channelName  ||
      this.selectedKit.channel3Gene == channelName  || this.selectedKit.channel4Gene == channelName || this.selectedKit.channel5Gene == channelName));
  }

  customSort(event: any) {
    let compResult = null;
    if(event.field == 'Result') {
      event.data.sort(( data1: RuleSet, data2: RuleSet)=> {
        compResult = data1.channelResult.localeCompare(data2.channelResult);
        return (event.order * compResult);
      });
    } else if(this.isChannelPresentInKit(event.field)) {
      let channelIndex = this.selectedChannels.indexOf(event.field);
      event.data.sort((data1: RuleSet, data2: RuleSet)=> {
        compResult = data1.channelValues[channelIndex].localeCompare(data2.channelValues[channelIndex]);
        return (event.order * compResult);
      });
    } else {
      return;
    }
  }
}
